module.exports = __webpack_public_path__ + "img/checkboxempty-svgrepo-com.5941ddb3.svg";